<template>
  <div id="App" style="min-height: inherit;">
    <LoadingOverlay v-show="isLoading" :message="getOverlayMessage"/>
    <router-view ref="routerView" key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LoadingOverlay from "@/components/shared/LoadingOverlay";

export default {
    name: 'App',
    components: {
        LoadingOverlay
    },
    computed: {
        ...mapGetters([ 'isLoading', 'getOverlayMessage' ])
    }
}
</script>

<style>
</style>
